export const PANDIUM_EVENTS = {
    contentHeightChange: 'pandium-content-height-change',
    allIntegrations: 'pandium-all-integrations',
    connectApp: 'pandium-connect-app',
    cancel: 'pandium-cancel', // to be deprecated — use installCancel
    installCancel: 'pandium-install-cancel',
    installNext: 'pandium-install-next',
    installBack: 'pandium-install-back',
    installSave: 'pandium-install-save',
    saveSync: 'pandium-save-sync',
    saveSyncError: 'pandium-save-sync-error',
    uninstall: 'pandium-uninstall',
    uninstallCancel: 'pandium-uninstall-cancel',
    connectionSettingsSave: 'pandium-connection-settings-save',
    connectionSettingsCancel: 'pandium-connection-settings-cancel',
    connectorConnect: 'pandium-connector-connect',
    connectorConnectCancel: 'pandium-connector-connect-cancel',
    connectorConnectNext: 'pandium-connector-connect-next',
    connectorConnectBack: 'pandium-connector-connect-back',
    connectorDisconnect: 'pandium-connector-disconnect',
    connectorDisconnectCancel: 'pandium-connector-disconnect-cancel',
}

/**
 * Send a postMessage event to the parent window or opener.
 * Used for iframe/popup communication with embedding applications.
 * Supports both iframe (window.parent) and popup (window.opener) modes.
 *
 * @param {string} eventName - The event name (e.g., 'pandium-install-cancel')
 * @param {object} options - Optional data to include
 * @param {object} options.tenant - Tenant object (will be formatted automatically)
 * @param {object} options.data - Additional data to spread into the message
 */
export const sendPandiumEvent = (eventName, { tenant, ...data } = {}) => {
    const message = {
        message: eventName,
        ...data,
    }

    if (tenant) {
        message.tenant = {
            id: tenant.id,
            name: tenant.name,
            integration: {
                id: tenant.integration?.id,
                name: tenant.integration?.name,
            },
        }
    }

    const dest = window.opener ?? window.parent
    dest.postMessage(message, '*')
}
